export default {
  StringJoin: {
    inputClaims: ['inputClaim'],
    inputClaimExample: ["['Admin','Author']"],
    inputParameters: [
      {
        id: 'delimiter',
        dataType: 'string',
        exampleValue: ',',
      },
    ],
    outputClaims: ['outputClaim'],
    outputClaimExample: ['Admin,Author'],
  },
  ChangeCase: {
    inputClaims: ['inputClaim1'],
    inputClaimExample: ['SomeOne@contoso.com'],
    inputParameters: [
      {
        id: 'toCase',
        dataType: 'string',
        options: ['LOWER', 'UPPER'],
        exampleValue: 'LOWER',
      },
    ],
    outputClaims: ['outputClaim'],
    outputClaimExample: ['someone@contoso.com'],
  },
  AddItemToStringCollection: {
    inputClaims: ['item', 'collection'],
    inputParameters: [],
    outputClaims: ['collection'],
  },
  CreateRandomString: {
    inputClaims: [],
    inputParameters: [
      { id: 'randomGeneratorType', dataType: 'string', options: ['GUID', 'INTEGER'], exampleValue: 'GUID' },
      { id: 'maximumNumber', dataType: 'int' },
      { id: 'seed', dataType: 'int' },
      { id: 'stringFormat', dataType: 'string' },
      { id: 'base64', dataType: 'boolean' },
    ],
    outputClaims: ['outputClaim'],
  },
  FormatStringClaim: {
    inputClaims: ['inputClaim'],
    inputParameters: [{ id: 'stringFormat', dataType: 'string' }],
    outputClaims: ['outputClaim'],
  },
  CreateAlternativeSecurityId: {
    inputClaims: ['key', 'identityProvider'],
    inputParameters: [],
    outputClaims: ['alternativeSecurityId'],
  },
  FormatStringClaim: {
    inputClaims: ['inputClaim'],
    inputParameters: [{ id: 'stringFormat', dataType: 'string' }],
    outputClaims: ['outputClaim'],
  },
  CreateStringClaim: {
    inputClaims: [],
    inputParameters: [{ id: 'value', dataType: 'string' }],
    outputClaims: ['createdClaim'],
  },
  AssertBooleanClaimIsEqualToValue: {
    inputClaims: ['inputClaim'],
    inputParameters: [{ id: 'valueToCompareTo', dataType: 'boolean', options: ['true', 'false'] }],
    outputClaims: [],
  },
  AssertStringClaimsAreEqual: {
    inputClaims: ['inputClaim1', 'inputClaim2'],
    inputClaimExample: ['far', 'Far'],
    inputParameters: [
      {
        id: 'stringComparison',
        dataType: 'string',
        options: ['Ordinal', 'OrdinalIgnoreCase'],
        exampleValue: 'OrdinalIgnoreCase',
      },
    ],
    outputClaims: [],
    outputClaimExample: [],
  },
  BuildUri: {
    inputClaims: ['path', 'query.secret'],
    inputClaimExample: ['emily@fabrikam.com', 'fay2lj7ynpntjgqa'],
    inputParameters: [
      {
        id: 'scheme',
        dataType: 'string',
        exampleValue: 'otpauth',
      },
      {
        id: 'host',
        dataType: 'string',
        exampleValue: 'totp',
      },
      {
        id: 'query.issuer',
        dataType: 'string',
        exampleValue: '{AuthenticatorIssuer}',
      },
    ],
    outputClaims: ['outputClaim'],
    outputClaimExample: [
      'otpauth://totp/Contoso%20demo:emily@fabrikam.com?secret=fay2lj7ynpntjgqa&issuer=Contoso+demo',
    ],
  },
  CompareClaims: {
    inputClaims: ['inputClaim1', 'inputClaim2'],
    inputClaimExample: ['someone@contoso.com', 'someone@outlook.com'],
    inputParameters: [
      {
        id: 'operator',
        dataType: 'string',
        options: ['EQUAL', 'NOT EQUAL'],
        exampleValue: 'NOT EQUAL',
      },
      {
        id: 'ignoreCase',
        dataType: 'boolean',
        exampleValue: true,
      },
    ],
    outputClaims: ['outputClaim'],
    outputClaimExample: [true],
  },
  CompareClaimToValue: {
    inputClaims: ['inputClaim1'],
    inputClaimExample: ['v1'],
    inputParameters: [
      {
        id: 'operator',
        dataType: 'string',
        options: ['EQUAL', 'NOT EQUAL'],
        exampleValue: 'EQUAL',
      },
      {
        id: 'compareTo',
        dataType: 'string',
        exampleValue: 'V1',
      },
      {
        id: 'ignoreCase',
        dataType: 'boolean',
        exampleValue: true,
      },
    ],
    outputClaims: ['outputClaim'],
    outputClaimExample: [true],
  },
  CopyClaimIfPredicateMatch: {
    inputClaims: ['inputClaim'],
    inputClaimExample: ['+11234567890'],
    inputParameters: [],
    outputClaims: ['outputClaim'],
    outputClaimExample: ['+11234567890'],
  },
  CreateOtpSecret: {
    inputClaims: [],
    inputClaimExample: ['+11234567890'],
    inputParameters: [],
    outputClaims: ['outputClaim'],
    outputClaimExample: ['hmlcmd4ph6fph64c'],
  },
  CreateStringClaim: {
    inputClaims: [],
    inputClaimExample: [],
    inputParameters: [
      {
        id: 'value',
        dataType: 'string',
        exampleValue: 'Contoso terms of service...',
      },
    ],
    outputClaims: ['outputClaim'],
    outputClaimExample: ['Contoso terms of service...'],
  },
  FormatLocalizedString: {
    inputClaims: ["['inputClaim1']"], // collection of input claims
    inputClaimExample: ["['sarah@contoso.com']"],
    inputParameters: [
      {
        id: 'stringFormatId',
        dataType: 'string',
        exampleValue: 'ResponseMessge_EmailExists', //String ID of the Localized string definition
      },
    ],
    outputClaims: ['outputClaim'],
    outputClaimExample: ['Output is based on localized string definition.'],
  },
  DoesClaimExist: {
    inputClaims: ['inputClaim'],
    inputClaimExample: ['someone@contoso.com'],
    inputParameters: [],
    outputClaims: ['outputClaim'],
    outputClaimExample: ['true'],
  },
  AndClaims: {
    inputClaims: ['inputClaim1', 'inputClaim2'],
    inputClaimExample: ['true', 'false'],
    inputParameters: [],
    outputClaims: ['outputClaim'],
    outputClaimExample: ['false'],
  },
  OrClaims: {
    inputClaims: ['inputClaim1', 'inputClaim2'],
    inputClaimExample: ['true', 'false'],
    inputParameters: [],
    outputClaims: ['outputClaim'],
    outputClaimExample: ['true'],
  },
  CompareBooleanClaimToValue: {
    inputClaims: ['inputClaim'],
    inputClaimExample: ['false'],
    inputParameters: [
      {
        id: 'valueToCompareTo',
        dataType: 'boolean',
        exampleValue: 'true',
      },
    ],
    outputClaims: ['compareResult'],
    outputClaimExample: ['false'],
  },
  NotClaims: {
    inputClaims: ['inputClaim'],
    inputClaimExample: ['false'],
    inputParameters: [],
    outputClaims: ['outputClaim'],
    outputClaimExample: ['true'],
  },
  CopyClaim: {
    inputClaims: ['inputClaim'],
    inputClaimExample: ['bob@contoso.com'],
    inputParameters: [],
    outputClaims: ['outputClaim'],
    outputClaimExample: ['bob@contoso.com'],
  },
  GetMappedValueFromLocalizedCollection: {
    inputClaims: ['mapFromClaim'],
    inputClaimExample: ['B2C_V1_90001'],
    inputParameters: [],
    outputClaim: ['restrictionValueClaim'],
    outputClaimExample: ["You can't sign in because you're a minor."],
  },
  FormatStringMultipleClaims: {
    inputClaims: ['inputClaim1', 'inputClaim2'],
    inputClaimExample: ['Joe', 'Fernando'],
    inputParameters: [
      {
        id: 'stringFormat',
        dataType: 'string',
        exampleValue: '{0} {1}',
      },
    ],
    outputClaim: ['outputClaim'],
    outputClaimExample: ['Joe Fernando'],
  },
};
